export const ErrorTypes = {
  'User is not confirmed.': 'errors.userNotConfirmed',
};
